var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useCannyContext } from "../../contexts";
const CannyChangelog = (props) => {
    const { component: Component = "button", align = "left", position = "bottom", labelIDs, children } = props, rest = __rest(props, ["component", "align", "position", "labelIDs", "children"]);
    const { isLoaded, appId, canny } = useCannyContext();
    useEffect(() => {
        if (isLoaded && appId) {
            canny.initChangelog({
                appID: appId,
                align,
                position,
                labelIDs
            });
            return () => canny.closeChangelog();
        }
    }, [isLoaded, appId, align, position, labelIDs]);
    return (_jsx(Component, Object.assign({}, rest, { "data-canny-changelog": "" }, { children: children }), void 0));
};
export { CannyChangelog };
